import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { from, of, timer } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AppInsightsMonitoringService, LogLevelEnum } from 'src/app/shared/services/app-insights';
import { APP_INSIGHTS_APP_SERVICE } from 'src/app/shared/services/app-insights/events/app-service.events';

import { ViToast } from '../components/toast/toast';
import { ViToastService } from '../components/toast/toast.service';

@Injectable()
export class ViAppService {
  private promptEvent: any;

  constructor(
    private toastService: ViToastService,
    private swUpdate: SwUpdate,
    private appInsights: AppInsightsMonitoringService
  ) {
    this.initBeforeInstallPrompt();
  }

  checkNewVersion(toast: ViToast): void {
    if (this.swUpdate.isEnabled) {
      // Until we won't deal with all the pending tasks in zone
      // we cannot rely on isStable flag
      // First version check is set to SW timeout to register
      // to be sure we have one working
      timer(35 * 1000, 10 * 60 * 1000)
        .pipe(
          switchMap(() =>
            from(this.swUpdate.checkForUpdate()).pipe(
              catchError((error) => {
                this.appInsights.logEvent(
                  APP_INSIGHTS_APP_SERVICE.SW_UPDATE_CHECK_ERROR,
                  LogLevelEnum.DEBUG,
                  { error }
                );
                return of(false);
              })
            )
          )
        )
        .subscribe((isUpdateAvailable) => {
          if (!isUpdateAvailable) return;

          this.toastService.info(toast, { duration: 0 });
        });
    }
  }

  canInstallPwa(): boolean {
    return !!this.promptEvent;
  }

  installPwa(): void {
    const a2hsBtn: any = document.querySelector('.ad2hs-prompt'); // hide our user interface that shows our A2HS button
    if (a2hsBtn) {
      a2hsBtn.style.display = 'none'; // Show the prompt
    }

    this.promptEvent.prompt();
    this.promptEvent.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the A2HS prompt');
      } else {
        console.log('User dismissed the A2HS prompt');
      }
      this.promptEvent = null;
    });
  }

  private initBeforeInstallPrompt(): void {
    window.addEventListener('beforeinstallprompt', (event) => {
      event.preventDefault();
      this.promptEvent = event;
      this.showAddToHomeScreen();
    });
  }

  private showAddToHomeScreen(): void {
    const a2hsBtn: any = document.querySelector('.ad2hs-prompt');
    if (a2hsBtn) {
      a2hsBtn.style.display = 'block';
      a2hsBtn.addEventListener('click', this.installPwa.bind(this));
    }
  }
}
